const COLOR_TOKENS = new Set<string>([
  '--color-on-surface',
  '--color-inverse-surface',
  '--color-secondary-muted',
  '--color-secondary-strong',
  '--button-filled-disabled-container-color',
  '--button-outlined-disabled-label-color',
  '--button-text-label-color',
  '--shell-header-bg',
  '--shell-header-text',
  '--shell-header-subtext',
  '--shell-header-divider',
  '--shell-header-divider-line',
  '--shell-header-control-hover-bg',
  '--shell-header-control-hover-border',
  '--shell-nav-active-bg',
  '--shell-nav-active-text',
  '--shell-sidenav-footer-text',
  '--shell-sidenav-footer-divider',
  '--shell-client-switcher-link',
  '--shell-client-switcher-border',
  '--shell-client-switcher-dialog-selected-bg',
  '--shell-client-switcher-dialog-selected-accent',
  '--shell-client-switcher-dialog-radio-border',
]);

const FILTER_TOKENS = new Set<string>([
  '--icon-on-surface-filter',
  '--shell-header-logo-filter',
  '--shell-header-icon-filter',
  '--shell-nav-active-icon-filter',
  '--shell-sidenav-footer-icon-filter',
  '--shell-sidenav-footer-logo-filter',
]);

const THEME_TOKENS = [...COLOR_TOKENS, ...FILTER_TOKENS];

const HEX_COLOR = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

const FILTER_FUNCTION =
  '(?:brightness|contrast|saturate|sepia|invert)\\(\\d+(?:\\.\\d+)?%?\\)|hue-rotate\\(\\d+(?:\\.\\d+)?deg\\)';

const FILTER_VALUE = new RegExp(`^(?:${FILTER_FUNCTION})(?:\\s+(?:${FILTER_FUNCTION}))*$`);

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && value !== undefined && typeof value === 'object' && !Array.isArray(value);
}

function themeTokenValue(token: string, raw: unknown): string | null {
  if (typeof raw !== 'string') {
    return null;
  }
  const value = raw.trim();
  if (COLOR_TOKENS.has(token)) {
    return HEX_COLOR.test(value) ? value : null;
  }
  if (FILTER_TOKENS.has(token)) {
    const normalized = value.toLowerCase();
    if (normalized === 'none' || normalized === 'unset') {
      return normalized;
    }
    return FILTER_VALUE.test(value) ? value : null;
  }
  return null;
}

/** Clears inline theme tokens, then applies a non-empty `theme_colors` object. */
export function applyDocumentThemeColors(colors: unknown): void {
  const root = document.documentElement;
  root.removeAttribute('data-theme');
  for (const token of THEME_TOKENS) {
    root.style.removeProperty(token);
  }
  if (!isPlainObject(colors) || Object.keys(colors).length === 0) {
    return;
  }
  for (const [token, raw] of Object.entries(colors)) {
    const value = themeTokenValue(token, raw);
    if (value !== null) {
      root.style.setProperty(token, value);
    }
  }
}
